"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lightSpeedIn = void 0;
const gsap_1 = require("gsap");
const lightSpeedIn = (target) => {
    return gsap_1.gsap
        .timeline({ defaults: { ease: gsap_1.Power2.easeInOut } })
        .fromTo(target, {
        duration: 0,
        skewX: 0,
        opacity: 0,
        x: '150%',
    }, {
        duration: 0.1,
        skewX: -90,
        opacity: 0,
        x: '150%',
    })
        .to(target, {
        duration: 0.2,
        skewX: -10,
        opacity: 1,
        x: '10%',
    })
        .to(target, { duration: 0.2, skewX: 10, x: '-10%' })
        .to(target, { duration: 0.1, skewX: -5, x: '5%' })
        .to(target, { duration: 0.1, skewX: 0, x: '0%' })
        .to(target, { duration: 0.1, skewX: 0, x: '0%' })
        .to(target, { duration: 0.2, skewX: 0, x: '0%' });
};
exports.lightSpeedIn = lightSpeedIn;
//# sourceMappingURL=light-speed-in.js.map